
declare var Object: any;
export interface FacilityAddressInterface {
  "name"?: string;
  "address"?: string;
  "id"?: any;
}

export class FacilityAddress implements FacilityAddressInterface {
  "name": string;
  "address": string;
  "id": any;
  constructor(data?: FacilityAddressInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `FacilityAddress`.
   */
  public static getModelName() {
    return "FacilityAddress";
  }

  /**
  * This method creates an instance of FacilityAddress for dynamic purposes.
  **/
  public static factory(data: FacilityAddressInterface): FacilityAddress{
    return new FacilityAddress(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FacilityAddress',
      plural: 'FacilityAddresses',
      path: 'FacilityAddresses',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
